
import { addFault } from '@/api/order';
import { getFault } from '@/api/other';
import { UserModule } from '@/store/modules/user';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

import OrderItemSearch from '@/components/OrderItemSearch/index.vue';

@Component({
  name: 'EditDialog',
  components: {
    OrderItemSearch }
})
export default class extends Vue {
  @Prop({
    type: Boolean,
    default: false
  })
  faultItemVisibility!: any;
  @Prop({
    type: String,
    default: ''
  })
  companyId!: string;
  @Prop({
    type: Object,
    default: () => {}
  })
  orderDetail!: any;
  @Prop({
    type: Boolean,
    default: false
  })
  isPhenomenon:any

   @Prop({
     type: Number,
     default: 1
   })
  enterType!: any;
  // 1 报修添加 2 添加订单 3 处理

  private isShowSearch = false

  private formInformation:any={
    faultTypeParent: '',
    faultType: ''
  }
  private faultList: any = [];
  private faultList2: any = [];

  created() {
    this.getFault(0, true);
  }
  // 获取故障类型类表
  private getFault(pid: any, isSet0:any) {
    const params:any = {
      user_id: UserModule.getUserId,
      company_id: this.companyId,
      pid: pid,
      name: '',
      is_need_child: 0,
      page: 1,
      size: 9999
    };
    if (this.isPhenomenon) {
      params.type = 2;
    }
    getFault(params)
      .then((res: any) => {
        if (res.data && res.data.list) {
          if (pid === 0) {
            this.faultList = res.data.list;
          } else {
            this.faultList2 = res.data.list;
            if (isSet0) {
              this.formInformation.faultType = this.faultList2[0];
            }
          }
        } else {
          if (pid === 0) {
            this.faultList = [];
          } else {
            this.faultList2 = [];
          }
        }
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }
  private comfirmSelectFault() {
    switch (this.enterType) {
      case 1:
        this.$emit('comfirmHandle', this.formInformation);
        break;
      case 2:
        this.$emit('comfirmHandle', this.formInformation);
        break;
      case 3:
        this.addFaultHandle(
          this.formInformation.faultTypeParent,
          this.formInformation.faultType
        );
        break;
    }
  }
  private addFaultHandle(valp: any, val: any) {
    if (!valp) {
      this.showErrorMsg('请选择故障类型');
      return;
    }
    const params: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: this.companyId,
      p_fault_type_id: valp.id,
      p_fault_type_name: valp.name,
      fault_type_id: val.id,
      fault_type_name: val.name,
      level: val.level
    };
    if (this.orderDetail.order) {
      params.order_id = this.orderDetail.order.id;
    }
    if (this.orderDetail.order_service) {
      params.order_service_id = this.orderDetail.order_service.id;
    }
    if (this.orderDetail.order_task) {
      params.order_task_id = this.orderDetail.order_task.id;
    }
    addFault(params)
      .then((res: any) => {
        this.showSuccessMsg(res.msg);
        this.formInformation.faultTypeParent = '';
        this.formInformation.faultType = '';
        this.$emit('comfirmHandle', false);
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }
  // 选中故障类型
  private selectFault(val: any) {
    if (val.id) {
      // 东改 用户可能删除故障类型
      this.formInformation.faultType = {};
      this.getFault(val.id, true);
    }
    // this.faultList2 = val.children;
  }
  close() {
    this.formInformation.faultTypeParent = '';
    this.formInformation.faultType = '';
    this.$emit('close', false);
  }
  // 搜索
  private searchItemHandle(val: any) {
    this.isShowSearch = val;
  }
  private searchConfirm(val:any) {
    this.$set(this.formInformation, 'faultTypeParent', { id: val.p_fault_type_id,
      name: val.p_fault_type_name });
    this.getFault(val.p_fault_type_id, false);
    this.$nextTick(() => {
      this.$set(this.formInformation, 'faultType', { id: val.fault_type_id,
        name: val.fault_type_name,
        level: val.level });
    });
  }

  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
}
